import { render } from "./ShippingView.vue?vue&type=template&id=d6f723e4&scoped=true"
import script from "./ShippingView.vue?vue&type=script&lang=js"
export * from "./ShippingView.vue?vue&type=script&lang=js"

import "./ShippingView.vue?vue&type=style&index=0&id=d6f723e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f723e4"]])

export default __exports__